import React from 'react'
import clsx from 'clsx'
import {
  // GridContentAlignment, // not available anymore
  GridDirection,
  // GridItemsAlignment, // not available anymore
  // GridJustification, // not available anymore
  GridWrap,
  Container,
  Grid,
  GridSize,
  GridSpacing,
  Paper,
} from '@mui/material'
import { Breakpoint, ResponsiveStyleValue } from '@mui/system'

import { useGlobalStyles } from '~shared/styles/globalStyles'

import { useGridContainerStyles } from './GridStyles'
import { GridContextProps, GridContext } from './GridContext'

// improvement proposal -- extend with OverridableComponent<GridTypeMap> and omit 'spacing' prop
// helper interface - since i was not able to extend OverridableComponent<GridTypeMap> correctly
// copied from Grid.d.ts
export type MuiGridProps = Partial<Record<Breakpoint, boolean | GridSize>> & {
  // alignContent?: GridContentAlignment
  // alignItems?: GridItemsAlignment
  container?: boolean
  direction?: ResponsiveStyleValue<GridDirection>
  item?: boolean
  // justifyContent?: GridJustification
  spacing?: GridSpacing
  wrap?: GridWrap
  zeroMinWidth?: boolean
};

// when extending GridContainerProps, dont forget to extract them in GridContainer
// so that rest props can safely be passed to <Grid>
interface GridContainerProps extends GridContextProps {
  containerMaxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false
  maxWidth?: 'Xs' | 'Sm' | 'Md' | 'Lg' | 'Xl'
  noHorizontalPadding?: boolean
  noVerticalPadding?: boolean
  elevation?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 20 | 21 | 22 | 23 | 24
  squareCornersTop?: boolean
  squareCornersBottom?: boolean
  roundCornersTop?: boolean
  roundCornersBottom?: boolean
}

//  Omit 'spacing' since gridSpacing should be used
export type Props = Omit<MuiGridProps, 'spacing'> & GridContainerProps & {
  className?: string
}

const GridContainer: React.FC<Props> = (props) => {
  const {
    gridSpacing,
    defaultColWidth,
    defaultRowSpacingHorizontal,
    maxWidth,
    noHorizontalPadding,
    noVerticalPadding,
    elevation,
    squareCornersTop,
    squareCornersBottom,
    roundCornersTop,
    roundCornersBottom,
    ...rest
  } = props

  const gs = useGlobalStyles()
  const s = useGridContainerStyles({ gridSpacing })

  return <GridContext.Provider value={{ gridSpacing, defaultColWidth, defaultRowSpacingHorizontal }}>
    <Paper
      elevation={elevation || 1}
      className={clsx(
        !!maxWidth && s[`maxWidth${maxWidth}`],
        squareCornersTop && gs.squareCornersTop,
        squareCornersBottom && gs.squareCornersBottom,
        roundCornersTop && gs.roundCornersTop,
        roundCornersBottom && gs.roundCornersBottom,
        props.className,
        // s.centerForm,
      )}
    >
      <Container
        className={clsx(
          s.gridContainer,
          // gs.alignLeft,
          gs.fullMaxWidth,
          // noHorizontalPadding && gs.noHorizontalPadding,
          // noVerticalPadding && gs.noVerticalPadding,
        )}
      >
        <Grid
          container
          spacing={gridSpacing}
          justifyContent='center'
          {...rest}
        >
          {props.children}
        </Grid>
      </Container>
    </Paper>
  </GridContext.Provider>
}

export default GridContainer
